<div [dfs]="['d:inline-block bg:92 p-v:5px p-h:8px b-l:2px bc:6 c:8', fullWidth && 'w:100%']"
     [style.borderStyle]="'solid'">
    <span *ngIf="title"
          [dfs]="'t:s2'">{{title}}:&nbsp;</span>
    <span [dfs]="'t:p2'"><ng-content></ng-content></span>
</div>